.masterclass-banner {
  overflow: hidden;
  position: relative;
  display: flex;
  border-radius: 4px;
  border: 1px solid;
  border-color: var(--chart-103-pressed);
  background-color: var(--white-layout-302-level-1-elevation);

  .header-title {
    font-weight: 500;
    line-height: 33px;
    color: var(--body-text-arrows-400);
  }

  .image-container {
    width: 50%;
    position: relative;

    img {
      position: absolute;
      right: 0;
      min-height: 100%;
      min-width: 100%;
      transform: scale(1.01);
    }
  }

  .data-container {
    width: 50%;
    padding: calc(var(--spacer) * 7) calc(var(--spacer) * 4.5) calc(var(--spacer) * 7) calc(var(--spacer) * 6);
  }
}
